<template>
  <div class="overlay-media-container" :style="'height:'+height+';width:'+width">
    <div class="overlay-media-tb">
      <div class="overlay-media-tbc">
        <center>
          <div>
            <b-spinner style="width: 4rem; height: 4rem;" label="Large Spinner"></b-spinner>
            <br>
          <p class="mt-3">Cargando curso...</p>
          </div>
        </center>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: String,
    width: String
  },
  created(){
    window.scrollTo(0, 0);
    setTimeout(()=>{
      document.body.style.overflow = "hidden";
    },200)
    
  },
  beforeDestroy(){
   document.body.style.overflow = "visible";
  }
};
</script>

<style scoped>
.overlay-media-container {
  transition: all 300ms ease;
  background: rgba(255, 255, 255, 1);
  z-index: 999;
  position: absolute;
}

.overlay-media-tb {
  height: 100%;
  width: 100%;
  display: table;
}
.overlay-media-tbc {
  width: 100%;
  display: table-cell;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// src/components/#public/curse/components/content/MediaLoader.vue